import TemplateRender from './TemplateRender'



const ScrollSection = ( { topicFrame ,handlers, tracking } ) => {
    return <TemplateRender trackingInfo={tracking} topicInfo={topicFrame} eventHandlers={handlers} />
}

export default ScrollSection;